module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result21-2566b28b277ee3b7d531e63d9744817a.png";